import * as yup from "yup";
import { PlanConsumerType } from "../../../../../common/enums";
import {
  fieldMaxLength,
  fieldMaxNumber,
  fieldMustBePositive,
  requiredField,
} from "../../../../../common/infrastructure/helpers/yupHelper";

export const planWizardFormSchema = yup
  .object({
    id: yup.number().required().defined(),
    studioId: yup.number().required().defined(),

    name: yup
      .string()
      .required(requiredField("Име на плана"))
      .trim()
      .max(200, fieldMaxLength("Име на плана", 200))
      .defined(),

    numberOfVisits: yup
      .number()
      .nullable()
      .when("isUnlimitedVisits", {
        is: true,
        then: (schema) =>
          schema
            .nullable()
            .transform((value, originalValue) =>
              originalValue === "" ? null : value
            )
            .default(null),
        otherwise: (schema) =>
          schema
            .required(requiredField("Брой на посещенията"))
            .positive(fieldMustBePositive("Брой на посещенията"))
            .max(200, fieldMaxNumber("Брой на посещенията", 200)),
      })
      .defined(),

    isUnlimitedVisits: yup.boolean().default(false).defined(),
    studioPlanTypeId: yup.number().nullable().defined(),

    durationNumber: yup
      .number()
      .nullable()
      .positive(fieldMustBePositive("Продължителност"))
      .required(requiredField("Продължителност"))
      .max(200, fieldMaxNumber("Продължителност", 200))
      .defined(),

    durationMetric: yup
      .number()
      .positive(fieldMustBePositive("Тип на продължителност"))
      .required(requiredField("Тип на продължителност"))
      .min(0)
      .defined(),

    consumerTypeId: yup
      .number()
      .nullable()
      .positive()
      .required(requiredField("Целева група"))
      .max(200, fieldMaxNumber("Целева група", 200))
      .defined(),

    price: yup
      .number()
      .nullable()
      .positive(fieldMustBePositive("Цена"))
      .required(requiredField("Цена"))
      .defined(),
  })
  .required();

export type IPlanWizardFormModel = yup.InferType<typeof planWizardFormSchema>;

export const planWizardFormDefaultValues: IPlanWizardFormModel = {
  id: 0,
  studioId: 0,
  name: "",
  numberOfVisits: 0,
  isUnlimitedVisits: false,
  studioPlanTypeId: null,
  durationNumber: null,
  durationMetric: 0,
  consumerTypeId: PlanConsumerType.User,
  price: null,
};
